<div class="subscription-change-checkboxes" [formGroup]="form">
  <div class="form-group checkbox">
    <input class="vox-checkbox mr-2" type="checkbox"
    (change)="onChangeInput()" formControlName="checkPayment"/>
    <label translate>company.dids.add-port-did.popup.form.checkbox.payment-label</label>
  </div>
  <div class="form-group checkbox">
    <input class="vox-checkbox mr-2" type="checkbox"
    (change)="onChangeInput()" formControlName="checkSubscription"/>
    <label translate>company.dids.add-port-did.popup.form.checkbox.subscription-label</label>
  </div>
</div>